module.exports = __webpack_public_path__ + "img/lqclzt2.07e7f615.svg";